
<template>
  <div class="pcib-order-help">
    <iframe src="/static/files/pcibOrderHelp_doc.html"></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  beforeCreate() {
    let self = this;
    let token = localStorage.getItem("authToken");
    let user = JSON.parse(localStorage.getItem("user"));
    // console.log(token, user, user.is_superuser);
    if (!token || !user || user.is_superuser) {
      this.$router.push({
        name: "pcibOrderLogin"
      });
    }
  }
};
</script>
<style lang="scss">
.pcib-order-help {
  width: 100%;
  height: 100%;
  background: #ffffff;

  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/mirrors/auths/PcibOrderHelp.vue